if (document.getElementById("main-menu")) {
    let header = document.getElementById("main-menu");
    let sticky = header.offsetTop;

    function stickyHeader() {
        if (window.pageYOffset > sticky) {
            header.classList.add("sticky");
        } else {
            header.classList.remove("sticky");
        }
    }

    window.onscroll = function () {
        stickyHeader()
    };
}

$(function () {
    if ($("#revo_slider").length > 0) {
        let revolutionSliders = {
            animateSlider: function () {
                $("#revo_slider").show().revolution({
                    sliderType: "standard",
                    sliderLayout: "fullscreen",
                    scrollbarDrag: "true",
                    dottedOverlay: "none",
                    delay: 9000,
                    muted: true,
                    navigation: {
                        bullets: {
                            enable: true,
                            direction: "vertical",
                            tmp: '<span class="tp-bullet-title">{{title}}</span>'
                        },
                        touch: {
                            touchenabled: "on",
                            swipe_threshold: 75,
                            swipe_min_touches: 1,
                            swipe_direction: "horizontal",
                            drag_block_vertical: false
                        }
                    },
                    viewPort: {
                        enable: true,
                        outof: "pause",
                        visible_area: "80%"
                    },
                    responsiveLevels: [1170, 992, 767, 480],
                    lazyType: "none",
                    parallax: {
                        type: "mouse",
                        origo: "slidercenter",
                        speed: 7000,
                        levels: [2, 3, 4, 5, 6, 7, 12, 16, 10, 50],
                        disable_onmobile: "on"
                    },
                    gridwidth: 1170,
                    gridheight: 720,
                    shadow: 0,
                    spinner: "off",
                    stopLoop: "off",
                    stopAfterLoops: -1,
                    stopAtSlide: -1,
                    shuffle: "on",
                    autoHeight: "off",
                    hideThumbsOnMobile: "off",
                    hideSliderAtLimit: 0,
                    hideCaptionAtLimit: 0,
                    hideAllCaptionAtLilmit: 0,
                    debugMode: false,
                    fallbacks: {
                        simplifyAll: "off",
                        nextSlideOnWindowFocus: "off",
                        disableFocusListener: false,
                    }
                });
            },
        };
        revolutionSliders.animateSlider();
    }

    if ($("#news-slider").length > 0) {
        let clientSlider = {
            sliderCall: function () {
                $("#news-slider").owlCarousel({
                    nav: true,
                    responsiveClass: true,
                    loop: true,
                    slideSpeed: 300,
                    dotsSpeed: 400,
                    navText: ['<i class="fas fa-angle-left" aria-hidden="true"></i>', '<i class="fas fa-angle-right" aria-hidden="true"></i>'],
                    items: 1,
                });
            }
        };
        clientSlider.sliderCall();
    }

    let navbars = {
        sideNavBar: function () {
            let $sideMenu = $('.side-menu-button > i');
            $('.side-menu-button').on('click', function () {
                $('.sidenav').toggleClass("app-sidebar");
                $(this).toggleClass("actives");
                $sideMenu.toggleClass("fa-bars");
                $sideMenu.toggleClass("fa-times");
            });
            $('#home-section .sidenav ul > li a').on('click', function () {
                $('.sidenav').removeClass("app-sidebar");
                $('.side-menu-button').removeClass("actives");
                $sideMenu.toggleClass("fa-bars");
                $sideMenu.toggleClass("fa-times");
            });
            $('#main-header .sidenav ul > li a').on('click', function () {
                $('.side-menu-button').removeClass("actives");
                $sideMenu.toggleClass("fa-bars");
                $sideMenu.toggleClass("fa-times");
            });
        },
        navbarColor: function () {
            $(window).on('scroll', function () {
                if ($(this).scrollTop() > 70) {
                    $('#home-section .navbar').addClass("shrink");
                    $('#home-section .navbar.red .navbar-brand > img').attr('src', '/assets/images/logo-black.svg');
                } else {
                    $('#home-section .navbar').removeClass("shrink");
                    $('#home-section .navbar.red .navbar-brand > img').attr('src', '/assets/images/logo-white.svg');
                }
            });
        }
    };
    navbars.sideNavBar();
    navbars.navbarColor();

    if ($(".gallery-slider").length > 0 || $(".partner-slider").length > 0 || $(".merch-slider").length > 0) {
        let gallerySlider = {
            sliderCall: function () {
                $(".gallery-slider").owlCarousel({
                    stagePadding: 50,
                    responsiveClass: true,
                    loop: true,
                    margin: 10,
                    autoHeight: true,
                    nav: true,
                    dots: false,
                    lazyLoad: true,
                    slideSpeed: 300,
                    responsive: {
                        0: {
                            items: 1
                        },
                        600: {
                            items: 3
                        },
                        1000: {
                            items: 6
                        }
                    }
                });
            },
            partnerCall: function () {
                $(".partner-slider").owlCarousel({
                    autoPlay: 3000,
                    responsiveClass: true,
                    loop: true,
                    margin: 20,
                    autoHeight: false,
                    nav: true,
                    dots: false,
                    lazyLoad: true,
                    slideSpeed: 300,
                    stopOnHover: true,
                    responsive: {
                        0: {
                            items: 1
                        },
                        600: {
                            items: 3
                        },
                        1000: {
                            items: 6
                        }
                    }
                });
            },
            merchCall: function () {
                $(".merch-slider").owlCarousel({
                    autoPlay: 3000,
                    nav: false,
                    dots: true,
                    responsiveClass: true,
                    loop: true,
                    slideSpeed: 300,
                    dotsSpeed: 400,
                    items: 1,
                });
            }
        };
        gallerySlider.sliderCall();
        gallerySlider.partnerCall();
        gallerySlider.merchCall();
    }

    $(".icheckbox, .iradio").iCheck({checkboxClass: 'icheckbox_minimal-grey', radioClass: 'iradio_minimal-grey'});

    let scroll = {
        onClickScroll: function () {
            $(".scroll").on('click', function (event) {
                event.preventDefault();
                $('html,body').animate({scrollTop: $(this.hash).offset().top}, 1000);
            });
        },
        mouseWheelScroll: function () {
            if (window.addEventListener) window.addEventListener('DOMMouseScroll', wheel, false);
            window.onmousewheel = document.onmousewheel = wheel;

            function wheel(event) {
                let delta = 0;
                if (event.wheelDelta) delta = event.wheelDelta / 120;
                else if (event.detail) delta = -event.detail / 3;

                handle(delta);
                if (event.preventDefault) event.preventDefault();
                event.returnValue = false;
            }

            function handle(delta) {
                let time = 500;
                let distance = 500;

                $('html, body').stop().animate({
                    scrollTop: $(window).scrollTop() - (distance * delta)
                }, time);
            }
        }
    };
    scroll.onClickScroll();

    $("select").on("select2:close", function (e) {
        $(this).valid();
    });

    let $required = $('.required');
    $required.prop('required', true);

    $('form input, select, textarea').each(function () {
        if ($(this).hasClass("required")) {
            $("label[for='" + this.id + "']").addClass('required-label');
        }
    });

    if ($("#appForm").length > 0) {
        $("#appForm").validate({
            normalizer: function (value) {
                return $.trim(value);
            },
            ignore: ".ignore",
            errorElement: "span",
            errorClass: "is-invalid",
            validClass: "is-valid",
            errorPlacement: function (error, element) {
            },
            highlight: function (element, errorClass, validClass) {
                let $el = $('#' + element.id);
                $el.parent().closest('.form-group').addClass('has-danger has-error');
                $el.removeClass(validClass);
                $el.addClass(errorClass);
            },
            unhighlight: function (element, errorClass, validClass) {
                let $el = $('#' + element.id);
                $el.parent().closest('.form-group').removeClass('has-danger has-error');
                $el.removeClass(errorClass);
                $el.addClass(validClass);
            },
        });
    }

    $('#btnLogout').on('click', function (e) {
        e.preventDefault();
        $('#logoutForm').submit();
    });

    if ($('[data-fancybox]').length > 0) {
        $('[data-fancybox]').fancybox({
            image: {
                preload: true
            },
            infobar: true,
            protect: true,
            youtube: {
                controls: 1,
                showinfo: 0
            },
            afterLoad: function (instance, current) {
                let pixelRatio = window.devicePixelRatio || 1;

                if (pixelRatio > 1.5) {
                    current.width = current.width / pixelRatio;
                    current.height = current.height / pixelRatio;
                }
            }
        });
    }

    if ($('[data-fancybox="gallery"]').length > 0) {
        $('[data-fancybox="gallery"]').fancybox({
            image: {
                preload: true
            },
            infobar: true,
            protect: true,
            loop: true,
            afterLoad: function (instance, current) {
                let pixelRatio = window.devicePixelRatio || 1;

                if (pixelRatio > 1.5) {
                    current.width = current.width / pixelRatio;
                    current.height = current.height / pixelRatio;
                }
            }
        });
    }

    function progressBars() {
        let progressBar = $('.bottom-section .progress .progress-bar');
        progressBar.css({width: 0});
        progressBar.each(function () {
            $(this).animate({width: $(this).attr("aria-valuenow") + "%"}, 2000)
        });
    }

    progressBars();

    if ($(window).width() > 767) {
        new WOW().init();
    }
    // if ($(window).width() < 768) {
    //     $('.vertical-heading').find('br').hide();
    // } else {
    //     $('.vertical-heading').find('br').show();
    // }

    /**
     * toastr plugin options
     */
    toastr.options = {
        "progressBar": true,
        "positionClass": "toast-bottom-right",
        "preventDuplicates": true,
        "closeButton": true,
        "escapeHtml": false,
        "timeOut": "6000"
    };

    let scrollTop = $(".scrollTop");
    $(window).scroll(function () {
        let topPos = $(this).scrollTop();

        if (topPos > 500) {
            $(scrollTop).css("opacity", "0.8");
        } else {
            $(scrollTop).css("opacity", "0");
        }
    });

    $(scrollTop).click(function () {
        $('html, body').animate({
            scrollTop: 0
        }, 800);
        return false;
    });
});
